import React, { useContext, useEffect, useRef, useState } from "react";
import { Dialog } from "../Dialog";
import { AppContext } from "../../contexts/AppContext";
import UsersTable from "../Tables/UsersTable";
import { getUsers } from "../../services/clients";
import { assignCourseToUsers } from "../../services/courses";
import { Button } from "../StyledElements";
import { useCourseContext } from "../../contexts/CoursesContext";
import swal from "sweetalert2";

export const AssignCourseUsersDialog = ({ show, onClose, onAssignedUsers = () => { } }) => {
  const { selectedClient } = useContext(AppContext);
  const { selectedCourse } = useCourseContext();
  const [users, setUsers] = useState([]);
  const [saveText, setSaveText] = useState("Assign Users");
  const selectedUsers = useRef([]);
  const filteredUsers = useRef([]);

  useEffect(() => {
    console.log("!!! SELECT USERS DIALOG");
    const fetchUsers = async () => {
      const users = await getUsers(selectedClient.public_id ?? selectedClient.id) ?? [];
      console.log("!!!USERS: ", users);
      setUsers(users);
    }

    if (show && (!users || users.length === 0)) {
      fetchUsers();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  const assignUsers = async () => {
    // Implement your save logic here, e.g., send data to backend or update state
    console.log("!!! SELECTED USERS: ", selectedUsers.current);
    setSaveText("Saving...");
    if (!selectedUsers.current || selectedUsers.current.length === 0) {
      swal.fire({
        title: "Error",
        text: "No users selected.",
        icon: "error",
      });
      setSaveText("Assign Users");
      return;
    }
    const results = await assignCourseToUsers(selectedCourse.public_id, selectedUsers.current, selectedClient.public_id ?? selectedClient.id);
    if (results.success) {
      onAssignedUsers(results.assigned_users);
      onClose();
    } else {
      setSaveText("Assign Users");
      swal.fire({
        title: "Error",
        text: results.message || "Failed to save recipients.",
        icon: "error",
      });
    }
  };

  return (
    <Dialog
      title="Assign Users to Course"
      subtitle={""}
      show={show}
      onClose={onClose}
      onOK={assignUsers}
      okText={saveText}
      closeText="Close"
      style={{ width: "90%", maxWidth: "1200px", height: "80vh", zIndex: 2000000000 }}
    >
      <div style={{ position: "absolute", top: "20px", right: "20px", zIndex: 2000000001 }}>
        <Button onClick={() => {
          selectedUsers.current = [...filteredUsers.current];
          assignUsers();
        }}
        >
          Add All Visible</Button>
      </div>
      <UsersTable users={users} hideTitle={true} hideButtons={true} mode="select" onSelect={(users) => {
        selectedUsers.current = [...users];
      }} onFilter={(users) => {
        filteredUsers.current = [...users];

      }} />
    </Dialog>
  );
};

export default AssignCourseUsersDialog;


